import { ActionButtonComponent } from '@myre/ui-primitive-components';
import { TranslatePipe } from '@myre/ui-primitive-core';

import { Component, inject, Input, type OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'myre-ui-cookies-banner',
  templateUrl: './cookies-banner.component.html',
  styleUrls: ['./cookies-banner.component.scss'],
  imports: [ActionButtonComponent, TranslatePipe],
})
export class CookiesBannerComponent implements OnInit {
  private readonly _cookieService = inject(CookieService);

  @Input()
  public cookieSuffix: string;

  @Input()
  public frontUserUrl: string;

  @Input()
  public domain: string;

  public displayBanner: boolean = false;

  public baseUrlApp: string;

  private _cookieBannerName: string;

  public ngOnInit(): void {
    this._cookieBannerName = `cookie-banner${this.cookieSuffix}`;
    this.baseUrlApp = this.frontUserUrl;

    const cookieValue = this._cookieService.get(this._cookieBannerName);

    if (cookieValue) {
      return;
    }

    this.displayBanner = true;
  }

  public accept(): void {
    this.displayBanner = false;
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 10);

    this._cookieService.set(this._cookieBannerName, '1', {
      expires,
      domain: location.host.includes('localhost') ? 'localhost' : this.domain,
      secure: false,
      path: '/',
    });
  }

  public close(): void {
    this.displayBanner = false;
  }
}
